import { CircularProgress, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React, { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRedirectOnAuth } from '../../aws/AuthHooks';
import { AuthContext, AuthState } from '../../aws/AuthProvider';
import { CustomDataGrid } from '../../components/data-grid/CustomDataGrid';
import { CustomModal } from '../../components/modal/CustomModal';
import { useStyles } from '../../theme/styles.helpers';
import { ROUTE } from '../routes';
import { Styles } from './FailedShopifyOrders.Styles';
import { GridRowParams } from '@mui/x-data-grid';
import { getFailedShopifyRequests } from '../../aws/RequestsApi';
import FailedShopifyOrderModal from '../../components/modals/failed-shopify-order';
import { Utils, Orders } from '@hellohair/types';

const FailedShopifyOrders: FC = () => {
  const [failedRequests, setFailedRequests] = useState<Orders.ShopifyOrder[]>([]);
  const [tempSurveys, setTempSurveys] = useState<Utils.SurveyMetaData[]>([]);
  const [selectedRequest, setSelectedRequest] = useState<Orders.ShopifyOrder | null>(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const styles = useStyles(Styles, {});
  const { apiClient } = useContext(AuthContext);
  useEffect(() => {
    setLoading(true);
    getFailedShopifyRequests(apiClient).then((res) => {
      setFailedRequests(res.failedOrders);
      setTempSurveys(res.tempSurveys);
      setLoading(false);
    });
  }, []);

  console.log('failedRequests: ', failedRequests);
  console.log('tempSurveys: ', tempSurveys);

  useRedirectOnAuth([AuthState.UNAUTHORIZED], ROUTE.LOGIN);

  const closeModal = () => {
    setSelectedRequest(null);
    setLoading(true);
    getFailedShopifyRequests(apiClient, 'network-only').then((res) => {
      setFailedRequests(res.failedOrders);
      setTempSurveys(res.tempSurveys);
      setLoading(false);
    });
  };

  const handleRowClicked = (params: GridRowParams) => {
    const s = failedRequests.find((r) => r.id === params.row.id);
    if (s) setSelectedRequest(s);
  };

  const mapRows = () => {
    return failedRequests.map((s) => {
      return {
        ...s,
        customer: `${s.customer.firstName} ${s.customer.lastName}`,
        email: s.customer.email,
      };
    });
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Typography variant="h3">{t('Faulty questionnaire')}</Typography>
        {loading && <CircularProgress color={'secondary'} size={24} thickness={5} />}
      </Box>

      <CustomDataGrid
        columns={[
          {
            field: 'name',
            headerName: t('Order'),
            flex: 1,
          },
          {
            field: 'customer',
            headerName: t('Customer'),
            flex: 1,
          },
          {
            field: 'email',
            headerName: t('E-Mail'),
            flex: 1,
          },
        ]}
        rows={mapRows()}
        onRowClick={handleRowClicked}
        isCellEditable={() => false}
        isRowSelectable={() => false}
        getRowId={(row) => row.name}
        pagination
        autoPageSize
        sx={styles.row}
        initialState={{
          sorting: {
            sortModel: [{ field: 'name', sort: 'asc' }],
          },
        }}
      />

      <CustomModal isModalOpen={!!selectedRequest} onModalClose={closeModal} variant="large">
        <FailedShopifyOrderModal selectedOrder={selectedRequest} onModalClose={closeModal} tempSurveys={tempSurveys} />
      </CustomModal>
    </Box>
  );
};

export default FailedShopifyOrders;
